var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"app":""}},[_c('notifications-bar'),_c('notification-alert',{attrs:{"EventTitle":_vm.eventTitle,"messageTitle":_vm.title,"message":_vm.message,"dialog":_vm.isNotification},on:{"close":function($event){_vm.closeNotifcation($event);
        _vm.isNotification = $event.status;}}}),_c('v-main',{staticClass:"pt-0"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }